export class Base {
    constructor(fieldName, value, fieldName2) {
        this.fieldName = fieldName;
        this.value = value;
        this.errors = new Array();
        if (fieldName2) {
            this.fieldName2 = fieldName2;
        }
    }
    getFieldname() {
        return this.fieldName;
    }
    getFieldname2() {
        return this.fieldName2;
    }
    getErrorMessages() {
        return this.errors;
    }
}
//# sourceMappingURL=base.js.map